
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface CodeEntryFormProps {
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  onSubmit: () => void;
  onResendCode: () => void;
  onChangePhone: () => void;
  isProcessing: boolean;
  cooldownTime: number;
}

export const CodeEntryForm = ({
  verificationCode,
  setVerificationCode,
  onSubmit,
  onResendCode,
  onChangePhone,
  isProcessing,
  cooldownTime
}: CodeEntryFormProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow numbers and limit to 6 digits
    const value = e.target.value.replace(/\D/g, '').substring(0, 6);
    setVerificationCode(value);
    
    // Auto-submit when 6 digits are entered
    if (value.length === 6 && !isProcessing) {
      onSubmit();
    }
  };

  return (
    <div className="space-y-6">
      <Input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        placeholder=""
        value={verificationCode}
        onChange={handleInputChange}
        className="text-center text-2xl tracking-widest h-14"
        autoFocus
        disabled={isProcessing}
      />
      
      <Button 
        variant="ghost" 
        className="w-full" 
        onClick={onResendCode} 
        disabled={cooldownTime > 0 || isProcessing}
      >
        {cooldownTime > 0 ? `Resend code (${cooldownTime}s)` : 'Resend code'}
      </Button>
    </div>
  );
};
